<template>
  <div id="visitor-pbadge-root" style="display: none">
    <div class="visitor-pbadge">
      <div class="visitor-pbadge-title">
        {{ badge?.schoolName?.toString()?.toUpperCase() || "Securly School" }}
      </div>
      <div class="visitor-pbadge-info-container">
        <img
          class="visitor-pbadge-profile-pic"
          :src="badge?.imageURL || '/img/avatars/user-avatar.jpeg'"
          @load="onImageLoad"
        />
        <div class="visitor-pbadge-info">
          <span class="visitor-pbadge-name">
            {{ badge?.firstName?.toString()?.toUpperCase() }}
            {{ badge?.lastName?.toString()?.toUpperCase() }}
          </span>
          <span class="visitor-pbadge-role">VISITOR</span>
          <span class="visitor-pbadge-reason">
            {{
              badge?.destination?.toString()?.toUpperCase()?.slice(0, 30) ||
              badge?.reasonForVisit?.toString()?.toUpperCase()?.slice(0, 30) ||
              ""
            }}
          </span>
          <span class="visitor-pbadge-date">{{ badge?.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xmlConstants from "@/constants/xmlConstants"

export default {
  name: "VisitorPrintBadge",
  props: {
    badge: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const print = () => {
      const printWindow = window.open(
        "Securly Print Badge",
        "",
        "height=900,width=1200"
      )
      const printContents = document.getElementById(
        "visitor-pbadge-root"
      ).innerHTML
      printWindow.document.open()
      printWindow.document.write(
        xmlConstants.usePrinterWindowTemplate(printContents)
      )
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    }

    const onImageLoad = () => {
      if ("print" in window && typeof window.print === "function") {
        print()
      }
    }

    return {
      onImageLoad
    }
  }
}
</script>

<style lang="scss"></style>
